import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import AsignarPerfilAUsuario from './AsignarPerfilAUsuario';

////Importación de actions.
import * as actions from '../actions/AsignarPerfilAUsuario';

const mapStateToProps = (state) => {
    return {
        data: state.asignarPerfilAUsuario,
        concierge: state.concierge
    }
}

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);
const Container = connect(mapStateToProps, mapDispatchToProps)(AsignarPerfilAUsuario);

export default Container;